export const selectedPackage = state => state.selectedPackage
